import { getReturnToUrl, getValidQueryParams } from 'src/dataLayer/localData/queryParams'

import declareContext from './declareContext'

const extractProperties = ({ environment, locale, queryParams }) => {
  const validQueryParameters = getValidQueryParams(queryParams)

  return {
    environment,
    locale,
    queryParams: validQueryParameters,
    redirectTo: getReturnToUrl(queryParams),
  }
}

const RouteParametersContext = declareContext(extractProperties)

const useRouteParamsContext = RouteParametersContext.useContext
const RouteParamsProvider = RouteParametersContext.Provider

export { RouteParamsProvider, useRouteParamsContext }
